import { ChatSticker } from 'types/interfaces/chat/ChatSticker';
import { ChatStickerPack } from 'types/interfaces/chat/ChatStickerPack';

import { httpClient } from './httpClient';

export const StickersApi = {
  async fetchStickerPacks() {
    const { data } = await httpClient.get<ChatStickerPack[]>('/sticker-packs');

    return data;
  },

  async fetchStickerPack(payload: { packId: number }) {
    const { data } = await httpClient.get<ChatStickerPack>(
      `/sticker-packs/${payload.packId}`
    );

    return data;
  },

  async fetchStickers(payload: { packId: number }) {
    const { data } = await httpClient.get<ChatSticker[]>(
      `/stickers/${payload.packId}`
    );

    return data;
  },
};
